import { render, staticRenderFns } from "./SubCommunityISO.vue?vue&type=template&id=5c25885a&scoped=true&"
import script from "./SubCommunityISO.vue?vue&type=script&lang=js&"
export * from "./SubCommunityISO.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityISO.vue?vue&type=style&index=0&id=5c25885a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25885a",
  null
  
)

export default component.exports